import { render, staticRenderFns } from "./ItemViewCard2.vue?vue&type=template&id=2150f80a&scoped=true"
import script from "./ItemViewCard2.vue?vue&type=script&lang=js"
export * from "./ItemViewCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2150f80a",
  null
  
)

export default component.exports